import React from 'react';
import { SectionCta } from './SectionCta';
import { AUTHOR_URL } from '../data/content';
const otherTitles = ['OBD2 Diagnostic Blueprint™', 'CAN Bus Diagnostic Blueprint™'];
export function AuthorSection() {
  return <section className="w-full bg-navy py-16 sm:py-24" aria-labelledby="author-title" data-id="element-33" data-mp="1775du8c1j8tq">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-34" data-mp="12aeyjn828h9d">
        <div className="grid items-center gap-8 md:grid-cols-[minmax(0,380px)_1fr] md:gap-12" data-id="element-35" data-mp="127iwpnt3d8fn">
          <img src={AUTHOR_URL} alt="Jason Mitchell in an automotive workshop" className="mx-auto aspect-[4/5] w-full max-w-sm rounded-2xl object-cover object-top md:max-w-none" loading="lazy" data-id="element-36" data-mp="ehg9bl04gqnd" />
          <div data-id="element-37" data-mp="jhuhr45my2lx">
            <p className="font-display text-lg font-bold uppercase tracking-wider text-spark" data-id="element-38" data-mp="jhb43zn0q0dp">Meet your author</p>
            <h2 id="author-title" className="mt-1 font-display text-5xl font-extrabold uppercase leading-none text-white sm:text-6xl" data-id="element-39" data-mp="3rwkzyq0be9d1">
              Jason Mitchell
            </h2>
            <p className="mt-2 text-lg font-semibold text-volt" data-id="element-40" data-mp="2zpffqntag3h4">Automotive Diagnostics Educational Author</p>
            <p className="mt-5 text-base leading-relaxed text-mist sm:text-lg" data-id="element-41" data-mp="34gfezzpvqxms">
              Jason Mitchell is the author behind our automotive diagnostic blueprint collection, including:
            </p>
            <ul className="mt-4 flex flex-col gap-2 sm:flex-row sm:flex-wrap" data-id="element-42" data-mp="2cphn2xvc7h2d">
              {otherTitles.map(t => <li key={t} className="rounded-lg border border-line bg-ink px-3 py-2 text-sm font-bold text-white" data-id="element-43" data-mp="2grmcfker5rj7">
                  {t}
                </li>)}
            </ul>
            <p className="mt-5 text-base leading-relaxed text-white sm:text-lg" data-id="element-44" data-mp="2qp0shiwrkeaz">
              The Automotive Parasitic Drain Diagnostic Blueprint™ continues the same practical editorial
              approach: organized diagnostic workflows, professional reference tools, and structured
              troubleshooting resources.
            </p>
          </div>
        </div>

        <SectionCta label="Learn Jason’s pathway today" data-id="element-45" data-mp="37gxo97rp8orb" />
      </div>
    </section>;
}